// src/hooks/useKeycloak.js
import Keycloak from 'keycloak-js';
import { useEffect, useRef, useState } from 'react';

const useKeycloak = () => {
  const [keycloak, setKeycloak] = useState<Keycloak | null>(null);
  const [loading, setLoading] = useState(true);
  const keycloakRef = useRef<Keycloak | null>(null);

  useEffect(() => {
    // Prevent creating multiple instances (React StrictMode runs effects twice)
    if (typeof window !== 'undefined' && !keycloakRef.current) {
      const keycloakInstance = new Keycloak({
        url: process.env.GATSBY_KEYCLOAK_BASE_URL,
        realm: process.env.GATSBY_KEYCLOAK_REALM,
        clientId: process.env.GATSBY_KEYCLOAK_CLIENT_ID,
      });

      keycloakRef.current = keycloakInstance;
      setKeycloak(keycloakInstance);
      setLoading(false);
    }
  }, []);

  return { keycloak, loading };
};

export default useKeycloak;
